const initWallPaperCardDeckWidget = () => {
    const selector = "[data-wallpaper-card-deck-widget] [data-slider]";
    const slider = document.querySelector(selector);
    if (slider) {
        const config = new CarouselConfig();
        config.sliderSelector = selector;
        config.cellAlign = CellAlign.left;
        config.contain = false;
        config.autoPlay = false;
        config.wrapAround = false;
        config.showArrows = false;
        config.activateCustomButtons = false;
        config.showDots = false;
        config.groupCells = false;
        config.adaptiveHeight = false;
        config.imagesLoaded = true;
        config.viewport = 1024;
        const responsiveCarousel = new ResponsiveCarousel();
        responsiveCarousel.initCarousel(config);
    }
};
